<div class="profile-settings-container">
  <div class="info-row" [attr.data-testid]="testIds.containerInfo">
    <h2 class="section-title" [attr.data-testid]="testIds.textTitle">Schlüsselspeicher</h2>
    <p class="section-description" [attr.data-testid]="testIds.textDescription">
      Hier verwalten Sie den kontoeigenen Sicherheitsschlüssel, der den Zugriff auf geschützte Chats steuert. Anhand des
      Schlüssles können Sie diese auf allen Ihren Geräten einsehen.
    </p>
  </div>

  <div class="key-text">Schlüssel für Ihre Chats</div>
  <div class="key-section" [attr.data-testid]="testIds.containerKeysection">
    <div class="key-row" [attr.data-testid]="testIds.containerKeyrow">
      <app-button
        [isPrimary]="true"
        text="Schlüssel eingeben"
        [dataTestId]="testIds.verifyKeybackup"
        onKeyUp="matDialog.open(verifySession)"
        (click)="matDialog.open(verifySession)">
      </app-button>
    </div>
  </div>
  <app-alert-box type="info" title="Schlüssel eingeben">
    Durch das Eingeben des Schlüssels entsperren Sie verschlüsselte Inhalte und können diese auf allen Ihren Geräten
    einsehen.
  </app-alert-box>
</div>

<hr />

<app-button
  [isPrimary]="false"
  class="reset-btn"
  text="Schlüssel neu vergeben"
  [dataTestId]="testIds.buttonResetpassword"
  (click)="resetKeyPassword()"
  onKeyUp="resetKeyPassword()"
  type="button">
</app-button>
<app-alert-box type="warning" title="Schlüssel neu vergeben">
  Beim Neuvergeben des Schlüssels verlieren alle bisherigen Schlüssel dauerhaft ihre Gültigkeit.
</app-alert-box>
<ng-template #verifySession>
  <div class="password-dialog-container" [attr.data-testid]="testIds.dialogSuggestion">
    <div class="header-container" [attr.data-testid]="testIds.containerSuggestionheader">
      <h1 class="header" [attr.data-testid]="testIds.textSuggestiontitle">SCHLÜSSEL EINGEBEN</h1>
      <h2 class="sub-header" [attr.data-testid]="testIds.textSuggestionsubtitle">
        Geben Sie hier den Schlüssel zu diesem TI-M-Account ein, um <br />
        die verschlüsselten Chatverläufe zu entsperren und darauf zuzugreifen. <br />
        <br />
        <br />
        Hinweis: Der Schlüssel dieses TI-M-Accounts wurde bei der <br />
        ersten Anmeldung eingerichtet - entweder von Ihnen oder von <br />
        einer anderen person, die diesen Account nutzt.
      </h2>
    </div>
    <form [formGroup]="verifyForm">
      <label for="password">Schlüssel <span class="required">*</span></label>
      <mat-form-field
        class="password-input copy-icon-right"
        subscriptSizing="dynamic"
        [attr.data-testid]="testIds.fieldSuggestion">
        <input
          id="password"
          [type]="isPasswordVisible ? 'text' : 'password'"
          matInput
          formControlName="password"
          required
          [attr.data-testid]="testIds.fieldSuggestionInput" />
        <button
          mat-icon-button
          matSuffix
          (click)="isPasswordVisible = !isPasswordVisible"
          [attr.data-testid]="testIds.buttonCopy"
          matTooltip="Passwort kopieren">
          <mat-icon [svgIcon]="isPasswordVisible ? 'eye' : 'eye-slash'"></mat-icon>
        </button>
      </mat-form-field>
      @if (showSpinner) {
        <div class="spinner-backdrop">
          <app-sb-spinner [type]="'spinnerIndeterminate'"></app-sb-spinner>
        </div>
      }
      <div class="button-container" [attr.data-testid]="testIds.containerSuggestionbuttons">
        <app-button
          (click)="matDialog.closeAll()"
          onKeyUp="matDialog.closeAll()"
          [dataTestId]="'button_generate'"
          text="Abbrechen">
        </app-button>
        <app-button
          [isPrimary]="true"
          (click)="verifyKeyBackup()"
          onKeyUp="verifyKeyBackup()"
          [isDisabled]="!verifyForm.valid"
          [dataTestId]="'button_confirm'"
          text="Bestätigen">
        </app-button>
      </div>
    </form>
  </div>
</ng-template>

@if (showSpinner) {
  <div [attr.data-testid]="testIds.spinnerBackdrop" class="spinner-backdrop">
    <app-sb-spinner class="verify-spinner" [type]="'spinnerIndeterminate'"></app-sb-spinner>
  </div>
}
